module.exports = __webpack_public_path__ + "static/media/zealix-3.78184195.jpg";